export function linkToMobileAuthRoute() {
  return "/mobile/auth";
}
